import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * 見出し付きの List コンポーネント（Item）
 * @param props
 * @returns
 */
export const HeadItem = (props) => {
    const { children, childrenWrapClassName = '', className = '', head } = props;
    return (_jsxs("li", Object.assign({ className: className }, { children: [_jsx(Text, Object.assign({ className: clsx('p-16', 'bg-gray-100'), color: 'base', isBold: true, size: 'sm' }, { children: head })), _jsx(Text, Object.assign({ className: clsx('p-16', 'bg-gray-50', 'break-all', 'whitespace-pre-wrap', childrenWrapClassName), color: 'base', size: 'sm' }, { children: children }))] })));
};
